import { Box, Typography, Container } from "@mui/material";
import { LinkedIn, GitHub, Facebook } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box component="footer" sx={{ py: 1, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <a href="i_quit_linkedin" target="_blank" rel="noopener noreferrer">
            <LinkedIn fontSize="large" />
          </a>
          <a
            href="https://github.com/shimul47"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GitHub fontSize="large" />
          </a>
          <a
            href="https://www.facebook.com/sohanurshimu1/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook fontSize="large" />
          </a>
        </Box>
        <Typography variant="body2" color="text.secondary" align="center">
          © {new Date().getFullYear()} ShimulBhai. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
